import * as React from "react";
import './SvgLocation.scss';  
const SvgLocation = () => (
  <svg
    className="animated"
    id="freepik_stories-location-search"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 500 500"
  >
    <g
      id="freepik--background-simple--inject-183"
      className="animable"
      style={{
        transformOrigin: "245.257px 247.246px",
      }}
    >
      <path
        d="M437.4,318.93s51.09-57.42,34.85-157.33-99.67-136.72-155-117.49-67.81,52.7-113,71.84-131.06,6-174,70.29,11.88,170.82,81.67,237.62S359.8,448.84,437.4,318.93Z"
        style={{
          fill: "#FF303D",
          transformOrigin: "245.257px 247.246px",
        }}
        id="eltbiom8pty8b"
        className="animable"
      />
      <g id="elknu2cnbd0ap">
        <path
          d="M437.4,318.93s51.09-57.42,34.85-157.33-99.67-136.72-155-117.49-67.81,52.7-113,71.84-131.06,6-174,70.29,11.88,170.82,81.67,237.62S359.8,448.84,437.4,318.93Z"
          style={{
            fill: "rgb(255, 255, 255)",
            opacity: 0.7,
            transformOrigin: "245.257px 247.246px",
          }}
          className="animable"
          id="eliuey52t6maq"
        />
      </g>
    </g>
    <g
      id="freepik--Plant--inject-183"
      className="animable"
      style={{
        transformOrigin: "56.69px 368.935px",
      }}
    >
      <line
        x1={38.25}
        y1={330.86}
        x2={50.9}
        y2={452.04}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "44.575px 391.45px",
        }}
        id="eln086mai0zv"
        className="animable"
      />
      <line
        x1={49.09}
        y1={434.9}
        x2={43.46}
        y2={428.97}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "46.275px 431.935px",
        }}
        id="elcx6tgp41nur"
        className="animable"
      />
      <path
        d="M45.32,430.91a6.94,6.94,0,0,0-2.44-5.19c-1.57-1.4-9.84-4.88-10.62-2C31.41,426.92,39.87,433.14,45.32,430.91Z"
        style={{
          fill: "#FF303D",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "38.7603px 426.997px",
        }}
        id="elodqrw0pt3zh"
        className="animable"
      />
      <line
        x1={45.32}
        y1={430.91}
        x2={37.45}
        y2={426.01}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "41.385px 428.46px",
        }}
        id="el0nkcu2s47j4"
        className="animable"
      />
      <line
        x1={50.49}
        y1={448.26}
        x2={44.99}
        y2={443.68}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "47.74px 445.97px",
        }}
        id="el8m87duxoy6"
        className="animable"
      />
      <path
        d="M46.85,445.62a6.91,6.91,0,0,0-2.43-5.19c-1.57-1.41-9.84-4.88-10.62-2C32.94,441.62,41.4,447.84,46.85,445.62Z"
        style={{
          fill: "#FF303D",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "40.2946px 441.704px",
        }}
        id="elew6c7fev13i"
        className="animable"
      />
      <line
        x1={46.85}
        y1={445.62}
        x2={38.98}
        y2={440.71}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "42.915px 443.165px",
        }}
        id="elyh3wotzu8wq"
        className="animable"
      />
      <line
        x1={45.27}
        y1={398.08}
        x2={39.71}
        y2={393.08}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "42.49px 395.58px",
        }}
        id="elihvcy3hd07p"
        className="animable"
      />
      <path
        d="M41.57,395a6.91,6.91,0,0,0-2.43-5.19c-1.58-1.4-9.84-4.88-10.63-2C27.66,391,36.12,397.24,41.57,395Z"
        style={{
          fill: "#FF303D",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "35.0103px 391.088px",
        }}
        id="elvzmnhi4fln"
        className="animable"
      />
      <line
        x1={41.57}
        y1={395.02}
        x2={33.7}
        y2={390.12}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "37.635px 392.57px",
        }}
        id="elhe74r3qw16"
        className="animable"
      />
      <line
        x1={46.82}
        y1={413.72}
        x2={41.25}
        y2={407.79}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "44.035px 410.755px",
        }}
        id="elq6lz9n8kkai"
        className="animable"
      />
      <path
        d="M43.11,409.73a6.94,6.94,0,0,0-2.44-5.19c-1.57-1.41-9.84-4.88-10.62-2C29.2,405.73,37.66,412,43.11,409.73Z"
        style={{
          fill: "#FF303D",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "36.5503px 405.822px",
        }}
        id="elgquny4xowqm"
        className="animable"
      />
      <line
        x1={43.11}
        y1={409.73}
        x2={35.24}
        y2={404.82}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "39.175px 407.275px",
        }}
        id="elpo76fayokrl"
        className="animable"
      />
      <line
        x1={42.79}
        y1={374.87}
        x2={37.22}
        y2={369.19}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "40.005px 372.03px",
        }}
        id="elcyww0v4af5t"
        className="animable"
      />
      <path
        d="M39.08,371.13a6.94,6.94,0,0,0-2.44-5.19c-1.57-1.41-9.83-4.88-10.62-2C25.17,367.13,33.63,373.35,39.08,371.13Z"
        style={{
          fill: "#FF303D",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "32.5203px 367.214px",
        }}
        id="elgh389dwt9dk"
        className="animable"
      />
      <line
        x1={39.08}
        y1={371.13}
        x2={31.21}
        y2={366.22}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "35.145px 368.675px",
        }}
        id="elpb8xpv32p18"
        className="animable"
      />
      <line
        x1={40.11}
        y1={349.32}
        x2={34.71}
        y2={345.19}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "37.41px 347.255px",
        }}
        id="eloycftwkn7bc"
        className="animable"
      />
      <path
        d="M36.57,347.13a6.91,6.91,0,0,0-2.43-5.19c-1.57-1.4-9.84-4.88-10.62-2C22.66,343.14,31.12,349.36,36.57,347.13Z"
        style={{
          fill: "#FF303D",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "30.0146px 343.217px",
        }}
        id="elemgymxp67t4"
        className="animable"
      />
      <line
        x1={36.57}
        y1={347.13}
        x2={28.7}
        y2={342.23}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "32.635px 344.68px",
        }}
        id="elgxn1nxt8uc7"
        className="animable"
      />
      <line
        x1={48.55}
        y1={426.73}
        x2={53.2}
        y2={419.15}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "50.875px 422.94px",
        }}
        id="elj7rc2yri1j"
        className="animable"
      />
      <path
        d="M51.78,421.43a7,7,0,0,1,1.31-5.59c1.25-1.69,8.62-6.8,10-4.11C64.56,414.65,57.57,422.48,51.78,421.43Z"
        style={{
          fill: "#FF303D",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "57.4696px 416.244px",
        }}
        id="elwaz4rs2clq"
        className="animable"
      />
      <line
        x1={51.78}
        y1={421.43}
        x2={57.32}
        y2={416.23}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "54.55px 418.83px",
        }}
        id="eler1afniswrv"
        className="animable"
      />
      <line
        x1={44.51}
        y1={388.03}
        x2={49.16}
        y2={380.44}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "46.835px 384.235px",
        }}
        id="elbvqvma8t7e4"
        className="animable"
      />
      <path
        d="M47.74,382.72a6.94,6.94,0,0,1,1.31-5.58c1.25-1.7,7-5.95,8.38-3.26C58.92,376.8,53.53,383.77,47.74,382.72Z"
        style={{
          fill: "#FF303D",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "52.6446px 377.918px",
        }}
        id="elcph5dwwv7m6"
        className="animable"
      />
      <line
        x1={47.74}
        y1={382.72}
        x2={54.83}
        y2={375.95}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "51.285px 379.335px",
        }}
        id="elsjkve9n9l3"
        className="animable"
      />
      <line
        x1={42.73}
        y1={371.02}
        x2={47.39}
        y2={363.43}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "45.06px 367.225px",
        }}
        id="el2ir6cylobdv"
        className="animable"
      />
      <path
        d="M46,365.71a6.89,6.89,0,0,1,1.31-5.58c1.24-1.7,8.61-6.8,10-4.12C58.75,358.93,51.76,366.76,46,365.71Z"
        style={{
          fill: "#FF303D",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "51.6829px 360.526px",
        }}
        id="elp6gioense1s"
        className="animable"
      />
      <line
        x1={45.97}
        y1={365.71}
        x2={53.05}
        y2={358.94}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "49.51px 362.325px",
        }}
        id="elc90ju4gm1i"
        className="animable"
      />
      <line
        x1={40.13}
        y1={346.08}
        x2={44.78}
        y2={338.5}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "42.455px 342.29px",
        }}
        id="elmhrvd7agjj"
        className="animable"
      />
      <path
        d="M43.36,340.78a6.94,6.94,0,0,1,1.31-5.58c1.25-1.7,8.62-6.81,10-4.12C56.15,334,49.15,341.83,43.36,340.78Z"
        style={{
          fill: "#FF303D",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "49.0495px 335.594px",
        }}
        id="elmfxen0x78b9"
        className="animable"
      />
      <line
        x1={43.36}
        y1={340.78}
        x2={50.45}
        y2={334}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "46.905px 337.39px",
        }}
        id="elc2rakcfbgpo"
        className="animable"
      />
      <path
        d="M38.14,330.14a6.94,6.94,0,0,1,1.31-5.58c1.25-1.7,8.62-6.8,10-4.12C50.93,323.36,43.93,331.19,38.14,330.14Z"
        style={{
          fill: "#FF303D",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "43.8295px 324.956px",
        }}
        id="eldc68srxq9oo"
        className="animable"
      />
      <line
        x1={38.14}
        y1={330.14}
        x2={45.23}
        y2={323.37}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "41.685px 326.755px",
        }}
        id="eljjhbssufy3"
        className="animable"
      />
      <path
        d="M38.55,330.43a6.93,6.93,0,0,1-5.41-1.88c-1.56-1.42-5.87-9.29-3.05-10.37C33.15,317,40.21,324.79,38.55,330.43Z"
        style={{
          fill: "#FF303D",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "33.9771px 324.26px",
        }}
        id="elnwul0yqgzd"
        className="animable"
      />
      <line
        x1={38.55}
        y1={330.43}
        x2={32.56}
        y2={322.68}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "35.555px 326.555px",
        }}
        id="elwtw6d5a0uqn"
        className="animable"
      />
      <line
        x1={58.47}
        y1={296.01}
        x2={58.47}
        y2={451.74}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "58.47px 373.875px",
        }}
        id="el6631pj3moto"
        className="animable"
      />
      <line
        x1={73.85}
        y1={348.67}
        x2={63.09}
        y2={452.34}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "68.47px 400.505px",
        }}
        id="elsc8u4p4ta9h"
        className="animable"
      />
      <line
        x1={63.27}
        y1={451.58}
        x2={60.16}
        y2={448.03}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "61.715px 449.805px",
        }}
        id="elvkkorkc7iml"
        className="animable"
      />
      <path
        d="M60.16,448a6.94,6.94,0,0,0-1.31-5.58c-1.25-1.7-8.62-6.8-10-4.11C47.37,441.26,54.37,449.09,60.16,448Z"
        style={{
          fill: "#FF303D",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "54.4705px 442.822px",
        }}
        id="ell90bs83memi"
        className="animable"
      />
      <line
        x1={60.16}
        y1={448.03}
        x2={53.47}
        y2={441.61}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "56.815px 444.82px",
        }}
        id="el667zwf9rwto"
        className="animable"
      />
      <line
        x1={67.06}
        y1={414.66}
        x2={62.45}
        y2={410.81}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "64.755px 412.735px",
        }}
        id="el5uao42e0gnh"
        className="animable"
      />
      <path
        d="M63.89,412.14a6.92,6.92,0,0,0-1.32-5.58c-1.25-1.7-8.62-6.8-10-4.12C51.1,405.37,58.1,413.19,63.89,412.14Z"
        style={{
          fill: "#FF303D",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "58.1964px 406.956px",
        }}
        id="el12d9ae4f0e5"
        className="animable"
      />
      <line
        x1={63.89}
        y1={412.14}
        x2={57.2}
        y2={405.72}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "60.545px 408.93px",
        }}
        id="ellduw9kjwrzj"
        className="animable"
      />
      <line
        x1={65.6}
        y1={432.15}
        x2={60.94}
        y2={424.57}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "63.27px 428.36px",
        }}
        id="elmmp2wxmp5id"
        className="animable"
      />
      <path
        d="M62.36,426.85a6.94,6.94,0,0,0-1.31-5.58c-1.25-1.7-8.62-6.8-10-4.12C49.57,420.08,56.57,427.9,62.36,426.85Z"
        style={{
          fill: "#FF303D",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "56.6705px 421.666px",
        }}
        id="elw7ak56f373"
        className="animable"
      />
      <line
        x1={62.36}
        y1={426.85}
        x2={55.67}
        y2={420.43}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "59.015px 423.64px",
        }}
        id="el2p3dzrgjy7w"
        className="animable"
      />
      <line
        x1={69.39}
        y1={391.09}
        x2={64.95}
        y2={385.97}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "67.17px 388.53px",
        }}
        id="elolc3zoeyq8e"
        className="animable"
      />
      <path
        d="M66.37,388.24a6.92,6.92,0,0,0-1.32-5.58c-1.25-1.69-8.62-6.8-10-4.11C53.58,381.47,60.58,389.3,66.37,388.24Z"
        style={{
          fill: "#FF303D",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "60.6764px 383.06px",
        }}
        id="elrgqvs0bjrq"
        className="animable"
      />
      <line
        x1={66.37}
        y1={388.24}
        x2={59.68}
        y2={381.83}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "63.025px 385.035px",
        }}
        id="elisql6t9cnz"
        className="animable"
      />
      <line
        x1={71.72}
        y1={368.63}
        x2={67.44}
        y2={361.97}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "69.58px 365.3px",
        }}
        id="elma9fghws8ao"
        className="animable"
      />
      <path
        d="M68.86,364.25a6.92,6.92,0,0,0-1.32-5.58c-1.25-1.7-8.62-6.8-10-4.12C56.07,357.48,63.07,365.3,68.86,364.25Z"
        style={{
          fill: "#FF303D",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "63.1664px 359.066px",
        }}
        id="el4o6nhiizse3"
        className="animable"
      />
      <line
        x1={68.86}
        y1={364.25}
        x2={62.17}
        y2={357.83}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "65.515px 361.04px",
        }}
        id="el2kogenqizvt"
        className="animable"
      />
      <line
        x1={64.18}
        y1={444.61}
        x2={70.3}
        y2={438.14}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "67.24px 441.375px",
        }}
        id="ellcx6olqn60f"
        className="animable"
      />
      <path
        d="M68.44,440.08a6.91,6.91,0,0,1,2.43-5.19c1.57-1.4,9.84-4.89,10.62-2C82.35,436.08,73.89,442.3,68.44,440.08Z"
        style={{
          fill: "#FF303D",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "74.9954px 436.163px",
        }}
        id="elokdq5pz9o4"
        className="animable"
      />
      <line
        x1={68.44}
        y1={440.08}
        x2={76.77}
        y2={434.91}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "72.605px 437.495px",
        }}
        id="el1ngkr699ebu"
        className="animable"
      />
      <line
        x1={68.2}
        y1={405.9}
        x2={74.31}
        y2={399.44}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "71.255px 402.67px",
        }}
        id="el505b8cm583s"
        className="animable"
      />
      <path
        d="M72.46,401.37a6.91,6.91,0,0,1,2.43-5.19c1.57-1.4,9.83-4.88,10.62-2C86.36,397.37,77.91,403.6,72.46,401.37Z"
        style={{
          fill: "#FF303D",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "79.0147px 397.456px",
        }}
        id="elyl0hufflzop"
        className="animable"
      />
      <line
        x1={72.46}
        y1={401.37}
        x2={80.79}
        y2={396.21}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "76.625px 398.79px",
        }}
        id="elijlmvwmd05j"
        className="animable"
      />
      <line
        x1={69.97}
        y1={388.89}
        x2={76.08}
        y2={382.43}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "73.025px 385.66px",
        }}
        id="el4cihkc7mmrx"
        className="animable"
      />
      <path
        d="M74.22,384.36a7,7,0,0,1,2.43-5.19c1.57-1.4,9.84-4.88,10.62-2C88.13,380.36,79.67,386.59,74.22,384.36Z"
        style={{
          fill: "#FF303D",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "80.7754px 380.446px",
        }}
        id="elhixpu13hl5"
        className="animable"
      />
      <line
        x1={74.22}
        y1={384.36}
        x2={82.55}
        y2={379.2}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "78.385px 381.78px",
        }}
        id="elt9owcm294p"
        className="animable"
      />
      <line
        x1={72.48}
        y1={362.68}
        x2={78.67}
        y2={357.49}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "75.575px 360.085px",
        }}
        id="elcfihc1ar8o"
        className="animable"
      />
      <path
        d="M76.81,359.43a6.91,6.91,0,0,1,2.43-5.19c1.57-1.41,9.84-4.89,10.62-2C90.72,355.43,82.26,361.65,76.81,359.43Z"
        style={{
          fill: "#FF303D",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "83.3654px 355.512px",
        }}
        id="elibxafsfg9lj"
        className="animable"
      />
      <line
        x1={76.81}
        y1={359.43}
        x2={85.14}
        y2={354.26}
        style={{
          fill: "#FF303D",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "80.975px 356.845px",
        }}
        id="el3b175kzsx9m"
        className="animable"
      />
      <path
        d="M73.89,347.94a6.92,6.92,0,0,1,2.43-5.19c1.57-1.4,9.83-4.88,10.62-2C87.79,343.94,79.34,350.17,73.89,347.94Z"
        style={{
          fill: "#FF303D",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "80.4447px 344.026px",
        }}
        id="el6wgfaydrxx"
        className="animable"
      />
      <line
        x1={73.89}
        y1={347.94}
        x2={82.22}
        y2={342.78}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "78.055px 345.36px",
        }}
        id="el41qpvpvxx8e"
        className="animable"
      />
      <path
        d="M74.23,348.31a6.92,6.92,0,0,1-4.91-3c-1.23-1.71-3.83-10.29-.85-10.77C71.71,334.07,77,343.13,74.23,348.31Z"
        style={{
          fill: "#FF303D",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "71.0492px 341.416px",
        }}
        id="elrnxpyysg60h"
        className="animable"
      />
      <line
        x1={74.23}
        y1={348.31}
        x2={69.96}
        y2={339.49}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "72.095px 343.9px",
        }}
        id="elycms209gasd"
        className="animable"
      />
      <line
        x1={58.25}
        y1={434.66}
        x2={53.19}
        y2={427.9}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "55.72px 431.28px",
        }}
        id="elwgubwb93zf"
        className="animable"
      />
      <path
        d="M54.84,430A6.91,6.91,0,0,0,53,424.61c-1.41-1.56-9.27-5.88-10.36-3.06C41.42,424.61,49.19,431.67,54.84,430Z"
        style={{
          fill: "#FF303D",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "48.6919px 425.434px",
        }}
        id="ely6hwmnkbe5"
        className="animable"
      />
      <line
        x1={54.84}
        y1={430.02}
        x2={47.52}
        y2={424.33}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "51.18px 427.175px",
        }}
        id="elyndy4ar22v"
        className="animable"
      />
      <line
        x1={58.43}
        y1={402.05}
        x2={53.19}
        y2={397.17}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "55.81px 399.61px",
        }}
        id="elzn24vlzh6d"
        className="animable"
      />
      <path
        d="M54.84,399.29A6.93,6.93,0,0,0,53,393.87c-1.41-1.56-9.27-5.87-10.36-3.06C41.42,393.87,49.19,400.93,54.84,399.29Z"
        style={{
          fill: "#FF303D",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "48.6928px 394.707px",
        }}
        id="elbckahaxpijh"
        className="animable"
      />
      <line
        x1={54.84}
        y1={399.29}
        x2={47.52}
        y2={393.59}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "51.18px 396.44px",
        }}
        id="el6i16lfwsp0i"
        className="animable"
      />
      <line
        x1={58.6}
        y1={368.14}
        x2={53.19}
        y2={361.08}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "55.895px 364.61px",
        }}
        id="elmda02nko3a"
        className="animable"
      />
      <path
        d="M54.84,363.2A6.91,6.91,0,0,0,53,357.79c-1.41-1.56-9.27-5.88-10.36-3.06C41.42,357.79,49.19,364.85,54.84,363.2Z"
        style={{
          fill: "#FF303D",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "48.6928px 358.621px",
        }}
        id="elsqhd8akl2x"
        className="animable"
      />
      <line
        x1={54.84}
        y1={363.2}
        x2={47.52}
        y2={357.51}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "51.18px 360.355px",
        }}
        id="el9igge4m8seb"
        className="animable"
      />
      <line
        x1={58.25}
        y1={341.62}
        x2={53.19}
        y2={337.06}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "55.72px 339.34px",
        }}
        id="el576tjxpqtfd"
        className="animable"
      />
      <path
        d="M54.84,339.18A6.93,6.93,0,0,0,53,333.76c-1.41-1.55-9.27-5.87-10.36-3.06C41.42,333.76,49.19,340.83,54.84,339.18Z"
        style={{
          fill: "#FF303D",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "48.6928px 334.599px",
        }}
        id="el3ws9abj3gau"
        className="animable"
      />
      <line
        x1={54.84}
        y1={339.18}
        x2={47.52}
        y2={333.48}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "51.18px 336.33px",
        }}
        id="elh3nqs5t42mh"
        className="animable"
      />
      <line
        x1={58.54}
        y1={317.59}
        x2={53.29}
        y2={313.74}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "55.915px 315.665px",
        }}
        id="el8bxxwkmwgp7"
        className="animable"
      />
      <path
        d="M54.84,315.05A6.91,6.91,0,0,0,53,309.64c-1.41-1.56-9.27-5.88-10.36-3.06C41.42,309.64,49.19,316.7,54.84,315.05Z"
        style={{
          fill: "#FF303D",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "48.6928px 310.471px",
        }}
        id="elwzavuf0kfj"
        className="animable"
      />
      <line
        x1={54.84}
        y1={315.05}
        x2={47.52}
        y2={309.36}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "51.18px 312.205px",
        }}
        id="el11s0l7rv8h1"
        className="animable"
      />
      <line
        x1={59.53}
        y1={442.83}
        x2={63.9}
        y2={437.29}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "61.715px 440.06px",
        }}
        id="elx8cc4nncsil"
        className="animable"
      />
      <path
        d="M62.25,439.41A7,7,0,0,1,64.13,434c1.42-1.56,9.28-5.87,10.36-3.06C75.67,434,67.9,441.05,62.25,439.41Z"
        style={{
          fill: "#FF303D",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "68.4168px 434.832px",
        }}
        id="elspyi73co27"
        className="animable"
      />
      <line
        x1={62.25}
        y1={439.41}
        x2={70}
        y2={433.41}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "66.125px 436.41px",
        }}
        id="elxswqcpvttdk"
        className="animable"
      />
      <line
        x1={58.48}
        y1={395.47}
        x2={63.9}
        y2={388.4}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "61.19px 391.935px",
        }}
        id="el7lrsl6lrnxd"
        className="animable"
      />
      <path
        d="M62.25,390.52a6.93,6.93,0,0,1,1.88-5.41c1.42-1.56,9.28-5.88,10.36-3.06C75.67,385.11,67.9,392.17,62.25,390.52Z"
        style={{
          fill: "#FF303D",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "68.4155px 385.941px",
        }}
        id="elnpttjv37b4"
        className="animable"
      />
      <line
        x1={62.25}
        y1={390.52}
        x2={70}
        y2={384.52}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "66.125px 387.52px",
        }}
        id="elucybnp9b5z"
        className="animable"
      />
      <line
        x1={58.48}
        y1={371.34}
        x2={63.9}
        y2={364.28}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "61.19px 367.81px",
        }}
        id="elhhww5y3hqoe"
        className="animable"
      />
      <path
        d="M62.25,366.4A7,7,0,0,1,64.13,361c1.42-1.56,9.28-5.87,10.36-3.06C75.67,361,67.9,368,62.25,366.4Z"
        style={{
          fill: "#FF303D",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "68.4172px 361.823px",
        }}
        id="el8oyzeaqd0hg"
        className="animable"
      />
      <line
        x1={62.25}
        y1={366.4}
        x2={70}
        y2={360.4}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "66.125px 363.4px",
        }}
        id="el2plwji8qska"
        className="animable"
      />
      <line
        x1={58.48}
        y1={339.45}
        x2={63.9}
        y2={332.39}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "61.19px 335.92px",
        }}
        id="elkkf8n8cycol"
        className="animable"
      />
      <path
        d="M62.25,334.51a7,7,0,0,1,1.88-5.42c1.42-1.56,9.28-5.87,10.36-3.06C75.67,329.09,67.9,336.16,62.25,334.51Z"
        style={{
          fill: "#FF303D",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "68.4164px 329.928px",
        }}
        id="el95hbrfugw5"
        className="animable"
      />
      <line
        x1={62.25}
        y1={334.51}
        x2={70}
        y2={328.51}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "66.125px 331.51px",
        }}
        id="elhwryf7p5csl"
        className="animable"
      />
      <line
        x1={58.72}
        y1={311.93}
        x2={64.02}
        y2={307.79}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "61.37px 309.86px",
        }}
        id="el5zpnxh8b15x"
        className="animable"
      />
      <path
        d="M62.25,309.44A7,7,0,0,1,64.13,304c1.42-1.56,9.28-5.87,10.36-3.06C75.67,304,67.9,311.08,62.25,309.44Z"
        style={{
          fill: "#FF303D",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "68.4156px 304.847px",
        }}
        id="elhtysm46azli"
        className="animable"
      />
      <line
        x1={62.25}
        y1={309.44}
        x2={70}
        y2={303.44}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "66.125px 306.44px",
        }}
        id="el7x0w42tf4f6"
        className="animable"
      />
      <path
        d="M58.16,298.32A7,7,0,0,1,60,292.9c1.42-1.56,9.28-5.87,10.36-3.06C71.58,292.9,63.81,300,58.16,298.32Z"
        style={{
          fill: "#FF303D",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "64.3085px 293.742px",
        }}
        id="elm8dy499qi09"
        className="animable"
      />
      <line
        x1={58.16}
        y1={298.32}
        x2={65.91}
        y2={292.32}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "62.035px 295.32px",
        }}
        id="elw3kvsnfvblm"
        className="animable"
      />
      <path
        d="M58.54,298.65a6.94,6.94,0,0,1-5.19-2.44c-1.4-1.57-4.87-9.84-2-10.62C54.56,284.74,60.77,293.2,58.54,298.65Z"
        style={{
          fill: "#FF303D",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "54.6292px 292.09px",
        }}
        id="el4vsu1jc3km"
        className="animable"
      />
      <line
        x1={58.54}
        y1={298.65}
        x2={53.38}
        y2={290.31}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "55.96px 294.48px",
        }}
        id="elfweifwadwbd"
        className="animable"
      />
    </g>
    <g
      id="freepik--Map--inject-183"
      className="animable"
      style={{
        transformOrigin: "248.275px 204.155px",
      }}
    >
      <g id="elbvj4qob3wha">
        <polygon
          points="93.31 157.58 149.81 166.73 242.13 154 310.96 172.28 380.39 156.79 444.76 279.91 341.02 304.39 241.47 294.13 125.12 305.1 51.78 275.85 93.31 157.58"
          style={{
            opacity: 0.2,
            transformOrigin: "248.27px 229.55px",
          }}
          className="animable"
          id="ele3geytslfrq"
        />
      </g>
      <polygon
        points="77.33 107.16 139.65 117.25 241.5 103.21 317.42 123.37 394.01 106.28 465.03 242.11 350.59 269.11 240.77 257.79 112.42 269.89 31.52 237.63 77.33 107.16"
        style={{
          fill: "rgb(255, 255, 255)",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "248.275px 186.55px",
        }}
        id="elpd2tzij8q5g"
        className="animable"
      />
      <polygon
        points="89.18 115.93 137.86 124.7 240.94 111.55 319.01 129.97 386.56 114.62 444.47 237.15 346.76 261.45 241.48 251.35 113.3 260.24 52.07 233.09 89.18 115.93"
        style={{
          fill: "#FF303D",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "248.27px 186.5px",
        }}
        id="elepj3c3x50fk"
        className="animable"
      />
      <g id="el68rrxy38nqu">
        <g
          style={{
            opacity: 0.64,
            transformOrigin: "235.745px 185.435px",
          }}
          className="animable"
          id="elw8q4gz30jfc"
        >
          <path
            d="M366.45,170.12,328.71,180H317.23s14.77,14.22,43.2,16.95,35-2.73,35-2.73Z"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "356.33px 183.917px",
            }}
            id="eluri0l6oc1uq"
            className="animable"
          />
          <polygon
            points="202.39 120.36 177.23 125.83 173.95 134.58 189.81 131.3 185.98 150.98 204.58 148.8 207.86 126.37 202.39 120.36"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "190.905px 135.67px",
            }}
            id="ellq75na46jz"
            className="animable"
          />
          <polygon
            points="186.53 154.26 184.89 164.11 195.83 161.92 195.83 153.72 186.53 154.26"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "190.36px 158.915px",
            }}
            id="elzlor86j18wb"
            className="animable"
          />
          <polygon
            points="179.97 154.26 177.78 165.2 156.45 167.94 157 160.28 179.97 154.26"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "168.21px 161.1px",
            }}
            id="elyqg8bz0zq3s"
            className="animable"
          />
          <path
            d="M306,202.94c-10.42,0-18.87,5.38-18.87,12s8.45,12,18.87,12,18.87-5.39,18.87-12S316.44,202.94,306,202.94Zm0,17.49c-4.74,0-8.58-2.44-8.58-5.46s3.84-5.47,8.58-5.47S314.6,212,314.6,215,310.76,220.43,306,220.43Z"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "306px 214.94px",
            }}
            id="elmhnneykht8r"
            className="animable"
          />
          <polygon
            points="156.45 246.14 171.22 210.04 138.41 211.69 133.48 224.26 148.79 224.26 137.31 250.51 156.45 246.14"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "152.35px 230.275px",
            }}
            id="elwrgjjs7q3bd"
            className="animable"
          />
          <polygon
            points="219.89 167.39 241.76 162.47 270.2 171.22 248.32 175.04 242.31 170.12 219.89 174.5 219.89 167.39"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "245.045px 168.755px",
            }}
            id="elzlc62qj4x7c"
            className="animable"
          />
          <polygon
            points="220.98 146.61 221.53 160.83 231.37 158.64 229.73 146.06 220.98 146.61"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "226.175px 153.445px",
            }}
            id="els7p68z41gw"
            className="animable"
          />
          <polygon
            points="84.81 154.26 76.06 179.42 111.61 188.72 117.08 169.03 101.77 154.81 84.81 154.26"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "96.57px 171.49px",
            }}
            id="elqdrfektj49"
            className="animable"
          />
        </g>
      </g>
      <path
        d="M437,221.33l-14.15-14c2.44-.31,4.8-.65,7.06-1l-1.77-3.76c-2.83.42-5.8.82-8.9,1.18L377.06,162c11.21-1.67,21.86-3.11,30-3.95l-1.81-3.82c-8.8.94-20,2.49-31.54,4.23l.12-.73-1.35-.21L357.61,142.8,391,123.93l-1.71-3.62-34.6,19.56-14.8-14.64-4.62,1,30.53,30.2L268.7,141.24c-.47-1.07-.94-2.14-1.37-3.24a130,130,0,0,1-6.44-21.75l-4.3-1a135,135,0,0,0,7,24.1l.48,1.17-22.75-3.57L217.84,139,217,114.6l-4,.51,2.19,66.75c-1.36,0-2.72,0-4-.06-36.95-1.07-76.86-11.85-82.77-15.07-4-2.21-13-12.62-17.79-18.53,9.79-.51,19.26-1.83,24.86-4.74,7.68-4,25.85-14.55,41.46-23.75L166.87,121c-13.33,7.81-26.88,15.63-33.21,18.91-11.33,5.88-41.67,4.66-53.32,3.94l-1.25,3.94c4.34.29,11.92.69,20.32.69,2,0,4.15,0,6.26-.08,1.5,1.9,14.65,18.46,20.84,21.84s46.37,14.45,84.57,15.55q2.11.06,4.29.06l.3,9.13-30.57.89-.46-.16-.06.17-60.72,1.77L67.8,183.45l-1.21,3.82L101.12,196l-32,44.63,3.74,1.65,32.46-45.22,18.14,4.59,59.73-1.74L165.8,249l-20.43,9,11.78-.81,84.32-37.12,60.17-32.23a99.12,99.12,0,0,0,22,11,176.87,176.87,0,0,0,21.53,6.05l-8.82,17.65L300,257l5.28.5,34.08-32.3.25-.24,9.62-19.24a211.31,211.31,0,0,0,30.68,3.52l-8.1,46,4.25-1.05L384,209.35c2.09.05,4.16.09,6.21.09a257.49,257.49,0,0,0,27.57-1.51l24.23,24ZM170.82,246.81l16.62-47L215.8,199l.91,27.63Zm192.36-86.68c-23.2,3.66-45.35,7.62-50.17,8.58l-4,.81c-4.28.89-10.95,2.28-19.05,3.8a99.09,99.09,0,0,1-19.33-27.72ZM218,143,241.15,141l24.74,3.88a106.52,106.52,0,0,0,19.51,29.32c-13.6,2.47-30.4,5.13-46.77,6.58l-.17-.25-.46.31c-6.4.55-12.72.92-18.76,1Zm1.4,42.8c3.88-.06,7.88-.24,11.93-.5l-11.68,7.88Zm20.42,30.62-19.14,8.42-.88-26.93,19.6-13.23c17.52-1.58,35.45-4.5,49.47-7.1a93.86,93.86,0,0,0,9.13,7.67ZM325,195a93.21,93.21,0,0,1-31.4-18.32c6.85-1.31,12.48-2.48,16.26-3.27l3.93-.81c7.14-1.43,33.4-6,58.33-9.85l42,41.53C388.87,206.71,356.47,206.12,325,195Z"
        style={{
          fill: "rgb(255, 255, 255)",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "254.3px 186.3px",
        }}
        id="el86hbwpyusvv"
        className="animable"
      />
      <line
        x1={119.27}
        y1={225.81}
        x2={112.86}
        y2={263.31}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "116.065px 244.56px",
        }}
        id="elp7hcxk9ca9a"
        className="animable"
      />
      <line
        x1={136.99}
        y1={122.07}
        x2={120.57}
        y2={218.19}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "128.78px 170.13px",
        }}
        id="elmi49t0d3g4"
        className="animable"
      />
      <line
        x1={240.67}
        y1={107.23}
        x2={241.22}
        y2={146.06}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "240.945px 126.645px",
        }}
        id="eluhamwnts268"
        className="animable"
      />
      <line
        x1={321.59}
        y1={153.3}
        x2={344.03}
        y2={247.78}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "332.81px 200.54px",
        }}
        id="eli0xecm09ygf"
        className="animable"
      />
      <line
        x1={315.59}
        y1={128.01}
        x2={320.52}
        y2={148.79}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "318.055px 138.4px",
        }}
        id="el733qry3n8ov"
        className="animable"
      />
      <line
        x1={241.76}
        y1={254.89}
        x2={241.22}
        y2={231.92}
        style={{
          fill: "rgb(255, 255, 255)",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "241.49px 243.405px",
        }}
        id="el7mn2ks3p6n"
        className="animable"
      />
    </g>
    <g
      id="freepik--Icon--inject-183"
      className="animable animator-hidden"
      style={{
        transformOrigin: "363.33px 60.33px",
      }}
    >
      <g id="elev9ofsuwngf">
        <circle
          cx={363.33}
          cy={60.33}
          r={13.33}
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "363.33px 60.33px",
            transform: "rotate(-13.36deg)",
          }}
          className="animable"
          id="el0a145v7traed"
        />
      </g>
      <path
        d="M369.77,59.12a7.07,7.07,0,1,0-7.07,7.06A7.07,7.07,0,0,0,369.77,59.12Z"
        style={{
          fill: "none",
          stroke: "rgb(255, 255, 255)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 2,
          transformOrigin: "362.7px 59.11px",
        }}
        id="elohckhcr60op"
        className="animable"
      />
      <line
        x1={367.54}
        y1={64.69}
        x2={372}
        y2={68.78}
        style={{
          fill: "none",
          stroke: "rgb(255, 255, 255)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 2,
          transformOrigin: "369.77px 66.735px",
        }}
        id="eluud8h87o6en"
        className="animable"
      />
    </g>
    <g
      id="freepik--search-bar--inject-183"
      className="animable animator-hidden"
      style={{
        transformOrigin: "223.775px 60.5px",
      }}
    >
      <path
        d="M330.07,75H117.47A14.47,14.47,0,0,1,103,60.5h0A14.47,14.47,0,0,1,117.47,46h212.6A14.47,14.47,0,0,1,344.55,60.5h0A14.47,14.47,0,0,1,330.07,75Z"
        style={{
          fill: "rgb(255, 255, 255)",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "223.775px 60.5px",
        }}
        id="elon0jy2ch4io"
        className="animable"
      />
    </g>
    <g
      id="freepik--Text--inject-183"
      className="animable animator-hidden"
      style={{
        transformOrigin: "169.35px 59.94px",
      }}
    >
      <path
        d="M128.17,55.75v1.46h-1.72V55.65c0-1.46-.58-2.34-1.91-2.34s-1.9.88-1.9,2.34v8.6c0,1.46.6,2.34,1.9,2.34s1.91-.88,1.91-2.34V62.13h1.72v2c0,2.47-1.16,4.09-3.67,4.09s-3.65-1.62-3.65-4.09v-8.4c0-2.47,1.16-4.09,3.65-4.09S128.17,53.28,128.17,55.75Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "124.51px 59.93px",
        }}
        id="el6kwer62p04r"
        className="animable"
      />
      <path
        d="M129.68,55.75c0-2.49,1.23-4.09,3.71-4.09s3.74,1.6,3.74,4.09v8.4c0,2.47-1.23,4.09-3.74,4.09s-3.71-1.62-3.71-4.09Zm1.78,8.5c0,1.48.63,2.34,1.93,2.34s1.93-.86,1.93-2.34v-8.6c0-1.46-.61-2.34-1.93-2.34s-1.93.88-1.93,2.34Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "133.405px 59.95px",
        }}
        id="els9e60d1roig"
        className="animable"
      />
      <path
        d="M144.4,59.39V61h-3.74v7h-1.81V51.82h6.45v1.65h-4.64v5.92Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "142.075px 59.91px",
        }}
        id="elfod1ngoy4a"
        className="animable"
      />
      <path
        d="M152.29,59.39V61h-3.74v7h-1.81V51.82h6.46v1.65h-4.65v5.92Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "149.97px 59.91px",
        }}
        id="elgevv2tsaeev"
        className="animable"
      />
      <path
        d="M160.42,59v1.63h-4v5.78h4.88v1.65h-6.69V51.82h6.69v1.65h-4.88V59Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "157.955px 59.94px",
        }}
        id="elq3yeoq976q"
        className="animable"
      />
      <path
        d="M168.78,59v1.63h-4v5.78h4.88v1.65H163V51.82h6.69v1.65h-4.88V59Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "166.345px 59.94px",
        }}
        id="el7xnycun4sb4"
        className="animable"
      />
      <path
        d="M182,55.72v.44h-1.71v-.53c0-1.46-.56-2.32-1.86-2.32s-1.86.86-1.86,2.3c0,3.64,5.46,4,5.46,8.57,0,2.46-1.19,4.06-3.67,4.06s-3.65-1.6-3.65-4.06v-.93h1.7v1c0,1.46.6,2.32,1.9,2.32s1.91-.86,1.91-2.32c0-3.62-5.44-4-5.44-8.55,0-2.51,1.16-4.06,3.6-4.06S182,53.26,182,55.72Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "178.37px 59.94px",
        }}
        id="elvxozf17mt"
        className="animable"
      />
      <path
        d="M185.41,60.76v7.32H183.6V51.82h1.81v7.32h4V51.82h1.81V68.08H189.4V60.76Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "187.41px 59.95px",
        }}
        id="elfbvdmn5jw6i"
        className="animable"
      />
      <path
        d="M192.93,55.75c0-2.49,1.23-4.09,3.72-4.09s3.74,1.6,3.74,4.09v8.4c0,2.47-1.24,4.09-3.74,4.09s-3.72-1.62-3.72-4.09Zm1.79,8.5c0,1.48.63,2.34,1.93,2.34s1.92-.86,1.92-2.34v-8.6c0-1.46-.6-2.34-1.92-2.34s-1.93.88-1.93,2.34Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "196.66px 59.95px",
        }}
        id="elbxceyfoynul"
        className="animable"
      />
      <path
        d="M205.66,51.82c2.55,0,3.64,1.51,3.64,4v2c0,2.58-1.2,3.93-3.78,3.93h-1.61v6.41H202.1V51.82ZM205.52,60c1.34,0,2-.62,2-2.18V55.7c0-1.49-.53-2.23-1.85-2.23h-1.75V60Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "205.7px 59.99px",
        }}
        id="el0itn5rwnc48h"
        className="animable"
      />
      <path
        d="M217.83,55.72v.44h-1.72v-.53c0-1.46-.56-2.32-1.86-2.32s-1.86.86-1.86,2.3c0,3.64,5.46,4,5.46,8.57,0,2.46-1.19,4.06-3.67,4.06s-3.65-1.6-3.65-4.06v-.93h1.7v1c0,1.46.6,2.32,1.9,2.32s1.91-.86,1.91-2.32c0-3.62-5.44-4-5.44-8.55,0-2.51,1.16-4.06,3.6-4.06S217.83,53.26,217.83,55.72Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "214.19px 59.94px",
        }}
        id="elqiwz7mz6tvo"
        className="animable"
      />
    </g>
    <g
      id="freepik--Character--inject-183"
      className="animable"
      style={{
        transformOrigin: "339.574px 330.999px",
      }}
    >
      <path
        d="M441.51,360.17h-59A11.5,11.5,0,0,0,371,371l-4.57,81h82.08L453,372.32A11.5,11.5,0,0,0,441.51,360.17Z"
        style={{
          fill: "rgb(38, 50, 56)",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "409.724px 406.085px",
        }}
        id="el6pcl3mg759q"
        className="animable"
      />
      <path
        d="M327.7,330.9s-30,6.35-32.58,9.74-53.32,87.17-53.32,87.17,2.11,20.74,5.5,20.31,2.54,2.54,14-5.07,33.86-26.24,33.86-26.24L307,451.93h99s.84-110.45-2.12-118.06-27.5-13.12-36-13.12S327.7,330.9,327.7,330.9Z"
        style={{
          fill: "rgb(255, 255, 255)",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "323.955px 386.34px",
        }}
        id="elp4yf0y57n4a"
        className="animable"
      />
      <path
        d="M325.3,369l6.77,6.77,29.31-54.14c-12.35,2.46-33.68,9.28-33.68,9.28s-15.07,3.19-24.76,6.25l-12.83,11.4c-11.28,18.22-38,62.2-46,75.43l3.2,24.14c3.36-.41,2.54,2.53,13.94-5.07s33.86-26.24,33.86-26.24l5.61,16.65c-1.36-7-6.74-35.27-4.77-40.21C298.22,387.61,325.3,369,325.3,369Z"
        style={{
          fill: "rgb(38, 50, 56)",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "302.745px 384.994px",
        }}
        id="elu4wowdz4cwd"
        className="animable"
      />
      <polygon
        points="321.35 344.16 295.4 381.97 295.4 360.53 321.35 344.16"
        style={{
          fill: "rgb(255, 255, 255)",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "308.375px 363.065px",
        }}
        id="elqg4qxdz99p"
        className="animable"
      />
      <path
        d="M332.52,388.11s-3.1,24.43-2.71,28.7,7.36,30.24,7.36,30.24"
        style={{
          fill: "rgb(255, 255, 255)",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "333.473px 417.58px",
        }}
        id="eldaqam55szr6"
        className="animable"
      />
      <path
        d="M329,328.47s-7.24,13.86-12.74,26.13-5.51,21.16-5.51,21.16,18.62-12.27,20.74-13.54,6.35-3.39,6.35-3.39l23.7,16.93s2.11-19.47,3-40.2-6.35-28.78-12.27-29.2S329,328.47,329,328.47Z"
        style={{
          fill: "rgb(255, 255, 255)",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "337.682px 341.057px",
        }}
        id="ells6wdajto2h"
        className="animable"
      />
      <path
        d="M272.28,286.49s-10.88,25.65-7.78,32.13,10.63-4.14,10.63-4.14,3.37,23.06,9.33,21.24,15-9.07,15-9.07,9.59,15.29,16.07,15.29S329,328.47,329,328.47s9.85-39.13,10.37-43.27-1.3-31.1-16.33-36.28S286,257.73,279.79,266,272.28,286.49,272.28,286.49Z"
        style={{
          fill: "rgb(38, 50, 56)",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "301.695px 294.869px",
        }}
        id="elraqq3v8ecdb"
        className="animable"
      />
      <path
        d="M287.5,308.05s-3.39,11.85-3.39,15.66-.84,17.35-1.27,19.89-43.58,55.44-49.93,66-9.73,20.32-3.39,28.78,12.7,11.43,17.78,9.73,4.65-.42,12.69-9.31,32.16-81.25,32.16-81.25,7.62-3.8,11-6.34,9.31-16.51,9.31-16.51Z"
        style={{
          fill: "rgb(173, 173, 173)",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "269.296px 378.31px",
        }}
        id="elysv7ad8xtoh"
        className="animable"
      />
      <path
        d="M229.52,438.39c6.35,8.46,12.7,11.43,17.78,9.73s4.65-.42,12.69-9.31c1.73-1.91,4.21-6.76,7-13.2-9.73,2.4-21.18,4-23.53,2.62-6.77-4-10.58-18.62-10.58-18.62C226.56,420.19,223.18,429.93,229.52,438.39Z"
        style={{
          fill: "rgb(255, 255, 255)",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "246.56px 429.095px",
        }}
        id="eligr9u580vq"
        className="animable"
      />
      <path
        d="M283.43,280.25s4,8.92,4,14.28-5.8,12.94-2.23,18.74,14.72,28.55,14.72,28.55,5.8,3.13,11.61,0,17.84-8.92,17.84-8.92-1.78,31.23.45,38.82,3.57,11.15,3.57,11.15,5.8-25.43,12-37,9.37-32.13,9.37-32.13-.45-8,0-16.06-12.05-38.82-32.13-45.51-31.23,0-36.59,8S283.43,280.25,283.43,280.25Z"
        style={{
          fill: "rgb(173, 173, 173)",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "318.748px 316.15px",
        }}
        id="elmntdgu9qpic"
        className="animable"
      />
      <path
        d="M295.93,307s6.69,8.48,15.62,1.34"
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "303.74px 309.1px",
        }}
        id="eljxo56d5u36b"
        className="animable"
      />
      <path
        d="M302.62,318.62s13.83,3.57,21-9.82"
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "313.12px 313.926px",
        }}
        id="elwrm6u020wti"
        className="animable"
      />
      <path
        d="M315.29,294c0,1.78-.93,3.23-2.07,3.23s-2.08-1.45-2.08-3.23.93-3.24,2.08-3.24S315.29,292.22,315.29,294Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "313.215px 293.995px",
        }}
        id="elo8zftmiau"
        className="animable"
      />
      <path
        d="M295.6,294c0,1.78-.93,3.23-2.07,3.23s-2.08-1.45-2.08-3.23.93-3.24,2.08-3.24S295.6,292.22,295.6,294Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "293.525px 293.995px",
        }}
        id="eltaxhjd3z95m"
        className="animable"
      />
      <path
        d="M311.66,278.2s6.22-.78,10.37,2.59"
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 2,
          transformOrigin: "316.845px 279.456px",
        }}
        id="el6edc03eyi9t"
        className="animable"
      />
      <path
        d="M297.15,278.2a12.63,12.63,0,0,0-8.29,3.11"
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 2,
          transformOrigin: "293.005px 279.755px",
        }}
        id="elaivcy6x39i"
        className="animable"
      />
      <polygon
        points="329.39 332.9 341.98 326.65 329.02 345.57 329.39 332.9"
        style={{
          fill: "rgb(38, 50, 56)",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "335.5px 336.11px",
        }}
        id="elpghdta65ktp"
        className="animable"
      />
      <path
        d="M338.76,219.56s-16.51-11.15-25.43-9.37-30.79,17-34.8,18.3-25.44,11.6-25.44,19.18,9.82,10.71,9.82,10.71-24.1,21-17.85,25,21.87-4.46,21.87-4.46-9.82,15.62-3.57,16.95S279,286.94,279,286.94s2.23,3.57,8.93-3.12,15.17-20.08,15.17-20.08-.89,8.92,4,7.58,11.16-10.26,11.16-10.26,4,41.05,10.26,37.93,6.25-7.14,6.25-7.14.44,16.51,4.46,15.17,6.25-5.8,6.25-5.8,4.46,16.95,9.81,16.51a6.83,6.83,0,0,0,6.25-5.36s1.34,18.74,12.94,14.73,13.39-16.51,13.39-16.51,8.47,9.82,13.38,2.68S403,297.2,403,297.2s8-.89,7.14-7.58-16.51-26.77-16.51-26.77,9.81,1.33,3.12-9.82-18.74-21-27.22-26.33a58.92,58.92,0,0,0-16.06-7.14s13.38-4.9,3.12-6.24S338.76,219.56,338.76,219.56Z"
        style={{
          fill: "rgb(38, 50, 56)",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "327.115px 268.83px",
        }}
        id="elbdqwh50ppjp"
        className="animable"
      />
      <path
        d="M374.39,371.25l2,35.4s-8-1.27-8,0S370,424,370,424s15.23,8.89,23.27,11,6.77,9.31,10.58,8,12.27-2.54,14-10.16-3-22-3.39-23.7-3-67.28-8.46-78.71-15.24-11.43-21.58-8.89-13.12,14-13.12,14"
        style={{
          fill: "rgb(255, 255, 255)",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "393.31px 381.666px",
        }}
        id="elk7b4m0fq7xc"
        className="animable"
      />
      <path
        d="M411.38,417.45c2,2.75,3.5,4.86,3.5,4.86"
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "413.13px 419.88px",
        }}
        id="elzfbe70qmzao"
        className="animable"
      />
      <path
        d="M380.17,405s16.51-.85,19.89,0c1.74.43,5.59,5,8.93,9.31"
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "394.58px 409.466px",
        }}
        id="elc3x6mjeo8sh"
        className="animable"
      />
      <path
        d="M401.76,399c5.07,1.69,6.34,3.8,6.34,3.8"
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "404.93px 400.9px",
        }}
        id="elwr3xlaj239"
        className="animable"
      />
      <path
        d="M381.87,401.15A107,107,0,0,1,393.09,399"
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "387.48px 400.075px",
        }}
        id="elvfe59jzggoq"
        className="animable"
      />
      <path
        d="M410.68,435.32c.46-7.52-8.11-21.61-18.23-23.17-11-1.69-29.63,6.77-54.59,9.74s-36.4,3.81-44.86,3.81-27.93-5.51-31.31-4.66-19.05,17.35-22.43,21.16-2.65,5-1.9,5.37S240,447,240,447s1.49,2.05,3.35,2.05a5.72,5.72,0,0,0,3.35-1.3,5.77,5.77,0,0,0,4.09.74c2.05-.56,14-8.56,14.89-8.93s6.7-2.05,6.7-2.05a73,73,0,0,1-10.24,6.7c-4.28,2-7.62,3.91-5.39,5s6-.18,8.93-1.48,6.7-3,8-3.17S285,439.38,285,439.38s8.37,1.86,12.28,2.24,12.47-3.17,12.47-3.17,30.89,5.4,46.52,6.33,40.56,4.46,48.93.18C405.19,445,410.21,443,410.68,435.32Z"
        style={{
          fill: "rgb(173, 173, 173)",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "323.713px 430.776px",
        }}
        id="eldfhr0lujvpc"
        className="animable"
      />
      <path
        d="M246.66,447.76s12.91-12.9,14.32-14,9.59-3.39,9.59-3.39"
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "258.615px 439.065px",
        }}
        id="elafp2xardk0o"
        className="animable"
      />
      <path
        d="M240,447s13.68-14.4,15.38-16.38,7.9-4.51,7.9-4.51"
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "251.64px 436.555px",
        }}
        id="el3ivpob8ab0r"
        className="animable"
      />
    </g>
    <g
      id="freepik--Locators--inject-183"
      className="animable animator-hidden"
      style={{
        transformOrigin: "236.73px 158.16px",
      }}
    >
      <path
        d="M103.1,144.67a9.29,9.29,0,0,0-9.29,9.3c0,5.13,9.29,14.7,9.29,14.7s9.3-9.57,9.3-14.7A9.3,9.3,0,0,0,103.1,144.67Zm0,13a3.15,3.15,0,1,1,3.15-3.14A3.15,3.15,0,0,1,103.1,157.66Z"
        style={{
          fill: "rgb(38, 50, 56)",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "103.105px 156.67px",
        }}
        id="elxuywqazazu"
        className="animable"
      />
      <path
        d="M199.6,101.67a9.29,9.29,0,0,0-9.29,9.3c0,5.13,9.29,14.7,9.29,14.7s9.3-9.57,9.3-14.7A9.3,9.3,0,0,0,199.6,101.67Zm0,13a3.15,3.15,0,1,1,3.15-3.14A3.15,3.15,0,0,1,199.6,114.66Z"
        style={{
          fill: "rgb(38, 50, 56)",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "199.605px 113.67px",
        }}
        id="el9ulvh6p7nc9"
        className="animable"
      />
      <path
        d="M183.86,167.16a9.29,9.29,0,0,0-9.3,9.29c0,5.14,9.3,14.7,9.3,14.7s9.29-9.56,9.29-14.7A9.29,9.29,0,0,0,183.86,167.16Zm0,13A3.14,3.14,0,1,1,187,177,3.14,3.14,0,0,1,183.86,180.14Z"
        style={{
          fill: "rgb(38, 50, 56)",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "183.855px 179.155px",
        }}
        id="elzpq9uh56e1h"
        className="animable"
      />
      <path
        d="M370.36,161.16a9.29,9.29,0,0,0-9.3,9.29c0,5.14,9.3,14.7,9.3,14.7s9.29-9.56,9.29-14.7A9.29,9.29,0,0,0,370.36,161.16Zm0,13A3.14,3.14,0,1,1,373.5,171,3.14,3.14,0,0,1,370.36,174.14Z"
        style={{
          fill: "rgb(38, 50, 56)",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "370.355px 173.155px",
        }}
        id="el9lbfrdnly6"
        className="animable"
      />
      <path
        d="M263.86,190.66a9.29,9.29,0,0,0-9.3,9.29c0,5.14,9.3,14.7,9.3,14.7s9.29-9.56,9.29-14.7A9.29,9.29,0,0,0,263.86,190.66Zm0,13A3.14,3.14,0,1,1,267,200.5,3.14,3.14,0,0,1,263.86,203.64Z"
        style={{
          fill: "rgb(38, 50, 56)",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "263.855px 202.655px",
        }}
        id="eldj4n7xwq7rq"
        className="animable"
      />
      <path
        d="M302.86,110.16a9.29,9.29,0,0,0-9.3,9.29c0,5.14,9.3,14.7,9.3,14.7s9.29-9.56,9.29-14.7A9.29,9.29,0,0,0,302.86,110.16Zm0,13A3.14,3.14,0,1,1,306,120,3.14,3.14,0,0,1,302.86,123.14Z"
        style={{
          fill: "rgb(38, 50, 56)",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "302.855px 122.155px",
        }}
        id="elup7j448kew"
        className="animable"
      />
    </g>
    <g
      id="freepik--Device--inject-183"
      className="animable"
      style={{
        transformOrigin: "175.296px 405.399px",
      }}
    >
      <rect
        x={82.62}
        y={447.15}
        width={189.56}
        height={5.42}
        style={{
          fill: "rgb(38, 50, 56)",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "177.4px 449.86px",
        }}
        id="elt4om6kiw93"
        className="animable"
      />
      <rect
        x={205.64}
        y={447.15}
        width={66.54}
        height={5.42}
        style={{
          fill: "#FF303D",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "238.91px 449.86px",
        }}
        id="elyqxowle54wm"
        className="animable"
      />
      <path
        d="M211,447.15H87.92l-7.11-81.86a6.37,6.37,0,0,1,6.45-7.06h109a7.85,7.85,0,0,1,7.67,7.06Z"
        style={{
          fill: "rgb(255, 255, 255)",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "145.886px 402.689px",
        }}
        id="elrrq4bpcappb"
        className="animable"
      />
      <path
        d="M208.64,447.15H85.56l-7.11-81.86a6.37,6.37,0,0,1,6.45-7.06h109a7.85,7.85,0,0,1,7.67,7.06Z"
        style={{
          fill: "#FF303D",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "143.526px 402.689px",
        }}
        id="elgssehojwpgt"
        className="animable"
      />
      <polygon
        points="203.16 384.02 85.56 447.15 208.64 447.15 203.16 384.02"
        style={{
          fill: "rgb(38, 50, 56)",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "147.1px 415.585px",
        }}
        id="elsj2yeqs6609"
        className="animable"
      />
      <g id="el2cofwv4ybsx">
        <ellipse
          cx={138.56}
          cy={400.11}
          rx={7.39}
          ry={8.06}
          style={{
            fill: "rgb(38, 50, 56)",
            stroke: "rgb(38, 50, 56)",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            transformOrigin: "138.56px 400.11px",
            transform: "rotate(-46.24deg)",
          }}
          className="animable"
          id="elnh6cvc30hg"
        />
      </g>
    </g>
    <g
      id="freepik--Mug--inject-183"
      className="animable animator-hidden"
      style={{
        transformOrigin: "448.688px 410.78px",
      }}
    >
      <path
        d="M470.25,416.1c-2.46-3.34-10.38-5.23-12.88-4v6.36c11.73-1.63,13.59,9.95,9.77,15.88a9.93,9.93,0,0,1-9.77,4.31v5.48c2,.7,5.67,1,10.22-2.69C474.7,435.65,475.81,423.62,470.25,416.1Z"
        style={{
          fill: "rgb(255, 255, 255)",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "465.573px 428.143px",
        }}
        id="elwy9w1rhac5"
        className="animable"
      />
      <rect
        x={423.6}
        y={402.84}
        width={34.65}
        height={49.24}
        style={{
          fill: "rgb(255, 255, 255)",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "440.925px 427.46px",
        }}
        id="el2i80nxpz9an"
        className="animable"
      />
      <path
        d="M430.6,374a8.28,8.28,0,0,1,.4-4.52"
        style={{
          fill: "none",
          stroke: "rgb(255, 255, 255)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "430.726px 371.74px",
        }}
        id="els9ujggp6ij"
        className="animable"
      />
      <path
        d="M431,397.5s7-4.5,4.5-11c-1.3-3.37-3-6.48-4.06-9.38"
        style={{
          fill: "none",
          stroke: "rgb(255, 255, 255)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "433.52px 387.31px",
        }}
        id="elbnhiolm65jd"
        className="animable"
      />
      <path
        d="M439,397.5s7-4.5,4.5-11c-.76-2-1.65-3.84-2.47-5.63"
        style={{
          fill: "none",
          stroke: "rgb(255, 255, 255)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "441.52px 389.185px",
        }}
        id="elro8yipbj73d"
        className="animable"
      />
      <path
        d="M450,383c-2.28-5-4.63-9.4-3-13.47"
        style={{
          fill: "none",
          stroke: "rgb(255, 255, 255)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "448.229px 376.265px",
        }}
        id="elv9a440nmis"
        className="animable"
      />
      <path
        d="M447,397.5s5.91-3.8,4.93-9.46"
        style={{
          fill: "none",
          stroke: "rgb(255, 255, 255)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "449.52px 392.77px",
        }}
        id="elu8uoytqeblf"
        className="animable"
      />
    </g>
    <g
      id="freepik--Table--inject-183"
      className="animable"
      style={{
        transformOrigin: "251px 452.06px",
      }}
    >
      <line
        x1={15}
        y1={452.06}
        x2={487}
        y2={452.06}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "251px 452.06px",
        }}
        id="eljxk3z9nl2ye"
        className="animable"
      />
    </g>
    <defs>
      <filter id="active" height="200%">
        <feMorphology
          in="SourceAlpha"
          result="DILATED"
          operator="dilate"
          radius={2}
        />
        <feFlood floodColor="#32DFEC" floodOpacity={1} result="PINK" />
        <feComposite in="PINK" in2="DILATED" operator="in" result="OUTLINE" />
        <feMerge>
          <feMergeNode in="OUTLINE" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
      <filter id="hover" height="200%">
        <feMorphology
          in="SourceAlpha"
          result="DILATED"
          operator="dilate"
          radius={2}
        />
        <feFlood floodColor="#ff0000" floodOpacity={0.5} result="PINK" />
        <feComposite in="PINK" in2="DILATED" operator="in" result="OUTLINE" />
        <feMerge>
          <feMergeNode in="OUTLINE" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
        <feColorMatrix
          type="matrix"
          values="0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
        />
      </filter>
    </defs>
  </svg>
);
export default SvgLocation;
